export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f4bf3dfbf4b60f5dc45b5f5c15b763dae8986f66&name=pushAdClickData!'